import type { ReactElement } from 'react';
import { useMemo } from 'react';
import { ChatAttachment, ChatAttachmentTypeEnum } from 'sdk';

import { styled } from '../../../../../styled';
import { Theme } from '../../../../../theme/interface/detailed';

const getSize = (size: number): string => {
	if (size > Math.pow(1024, 2)) {
		return (size / Math.pow(1024, 2)).toFixed(1) + ' MB ';
	}

	return (size / 1024).toFixed(1) + ' KB ';
};

const Component = ({ className, attachment }: { className: string; attachment: ChatAttachment }): ReactElement => (
	<div className={className}>
		<span>{useMemo(() => getSize(attachment.length), [attachment])}</span>
		<span>
			{useMemo(() => {
				const splitted = attachment.filename.split('.');
				if (splitted.length > 1) {
					return splitted[splitted.length - 1].toUpperCase();
				}

				return '';
			}, [attachment])}
		</span>
	</div>
);

export const FileDescription = styled(Component)(
	({
		theme: {
			allSettings: {
				attachments: {
					fileDescription: { clientColor, agentColor, ...others },
				},
			},
		},
		attachment,
	}: {
		theme: Theme;
		attachment: ChatAttachment;
	}) => ({
		color: attachment.type === ChatAttachmentTypeEnum.UserAttach ? clientColor : agentColor,
		...others,
	})
);
